module.exports = __webpack_public_path__ + "static/img/articledesign.afd2b9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articledesign.jpg
// module id = P4cs
// module chunks = 1